<script setup lang="ts">
import type { EmbedEventPayload } from "ls/features/embed-bridge/types";
import { useIframeListener } from "ls/composables/useIframeListener";
import { computed, useTemplateRef } from "vue";

const props = defineProps<{
  url: string;
}>();

const currentUrl = defineModel<string>("currentUrl");

const autoplaySupportedHosts = [
  "youtube.com",
  "youtu.be",
  "vimeo.com",
  "player.vimeo.com",
];

const iframe = useTemplateRef("iframe");
const { message: embedMessage } = useIframeListener<EmbedEventPayload>(iframe);

embedMessage.on(message => {
  if (message.key === "embed_reportCurrentUrl") {
    currentUrl.value = message.data.url;
  }
});

const embedUrl = computed(() => {
  try {
    const url = new URL(props.url);
    if (autoplaySupportedHosts.includes(url.hostname)) {
      url.searchParams.append("autoplay", "1");
    }
    return url.toString();
  } catch {
    return props.url;
  }
});
</script>

<template>
  <iframe
    ref="iframe"
    class="flex size-full flex-col bg-white"
    :src="embedUrl"
    :frameborder="0"
    :title="url"
    sandbox="allow-same-origin allow-scripts allow-storage-access-by-user-activation allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation"
    allow="autoplay;fullscreen"
  />
</template>
